/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { voice_ChildOption } from './voice_ChildOption';
export type voice_ClarificationRequest = {
    /**
     * ChildOptions lists available child matches when type is "child_ambiguous".
     */
    child_options?: Array<voice_ChildOption>;
    /**
     * Reason explains why clarification is needed.
     */
    reason?: string;
    /**
     * Type indicates why clarification is needed.
     * One of: "child_ambiguous", "activity_unclear", "observation_unclear"
     */
    type: voice_ClarificationRequest.type;
};
export namespace voice_ClarificationRequest {
    /**
     * Type indicates why clarification is needed.
     * One of: "child_ambiguous", "activity_unclear", "observation_unclear"
     */
    export enum type {
        CHILD_AMBIGUOUS = 'child_ambiguous',
        ACTIVITY_UNCLEAR = 'activity_unclear',
        OBSERVATION_UNCLEAR = 'observation_unclear',
    }
}

